import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { DateTime } from 'luxon';

export const i18nInit = () => {
  i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns: ['common'],
      defaultNS: 'common',
      backend: {
        loadPath: `${
          import.meta.env.VITE_API_ENDPOINT || ''
        }/api/language-file?lang={{lng}}`,
        allowMultiLoading: false,
        parse: (data: string) => {
          const parsed = JSON.parse(data);
          return parsed.common;
        },
      },
    });

  i18n.services.formatter?.add(
    'DATE_SHORT',
    (value: any, lng: any, options: any) => {
      return DateTime.fromJSDate(value)
        .setLocale(lng || 'en')
        .toLocaleString(DateTime.DATE_SHORT);
    }
  );

  i18n.services.formatter?.add(
    'DATETIME_SHORT',
    (value: any, lng: any, options: any) => {
      return DateTime.fromJSDate(value)
        .setLocale(lng || 'en')
        .toLocaleString(DateTime.DATETIME_SHORT);
    }
  );

  return i18n;
};

export default i18n;
